var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeImageRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 40,
    viewBox: "0 0 12 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 4,
    height: 4,
    fill: "#00ebff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 4,
    height: 4,
    fill: "#00ebff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 4,
    height: 4,
    fill: "#00ebff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 4,
    height: 4,
    fill: "#00ebff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 4,
    height: 4,
    fill: "#00ebff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 4,
    height: 4,
    fill: "#00ebff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 16,
    width: 4,
    height: 4,
    fill: "#00ebff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 4,
    height: 4,
    fill: "#00ebff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 20,
    width: 4,
    height: 4,
    fill: "#00ebff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 4,
    height: 4,
    fill: "#00ebff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 24,
    width: 4,
    height: 4,
    fill: "#00ebff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 4,
    height: 4,
    fill: "#00ebff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    y: 28,
    width: 4,
    height: 4,
    fill: "#00ebff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    fill: "#211A29"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    y: 36,
    width: 4,
    height: 4,
    fill: "#db4d42"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 32,
    width: 4,
    height: 4,
    fill: "#db4d42"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 28,
    width: 4,
    height: 4,
    fill: "#db4d42"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    y: 32,
    width: 4,
    height: 4,
    fill: "#211A29"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 24,
    width: 4,
    height: 4,
    fill: "#211A29"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 4,
    height: 4,
    fill: "#211A29"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 4,
    height: 4,
    fill: "#211A29"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 4,
    height: 4,
    fill: "#211A29"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 4,
    height: 4,
    fill: "#211A29"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 4,
    height: 4,
    fill: "#211A29"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 4,
    height: 4,
    fill: "#211A29"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 4,
    height: 4,
    fill: "#211A29"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 28,
    width: 4,
    height: 4,
    fill: "#211A29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeImageRight);
export default __webpack_public_path__ + "static/media/BadgeImage-Right.451a06f7718907d8db8baaba85fb263a.svg";
export { ForwardRef as ReactComponent };